import { render } from "./AppCustomize.vue?vue&type=template&id=86935170"
import script from "./AppCustomize.vue?vue&type=script&lang=js"
export * from "./AppCustomize.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__